/// <reference path='../_all.ts' />
declare var pglob : IPhotometerGlobalVar;

module part {
  'use strict';

  /**
   * Services that persists and retrieves TODOs from localStorage.
   */
  export class PartService implements IPartService {

    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$rootScope',
      '$http', 
      '$q', 
      'CacheFactory',
      'anchorNavService',
      '$mdDialog',
    ];

    private cacheName : string = "partCache"; //use different cache with capacity, because we can't store anything right now.
    
    constructor(
      private $rootScope: ng.IRootScopeService,
      private $http: ng.IHttpService,
      public $q: ng.IQService,
      public CacheFactory: CacheFactory.ICacheFactory,
      private anchorNavService: navigation.IAnchorNavService,
      private $mdDialog: ng.material.IDialogService      
      ) {}
    

    private getOrCreateCache() : CacheFactory.ICache {
      if (!this.CacheFactory.get(this.cacheName)) {
        this.CacheFactory.createCache(this.cacheName, {
          capacity: 10, //currently results in 1MB max size.
          storageMode: 'sessionStorage', // This cache will use `sessionStorage`.
          maxAge: 60 * 60 * 1000, // 60 minute
          deleteOnExpire: 'aggressive', //remove expired entries
        });
      }
      return this.CacheFactory.get(this.cacheName);
    }

    public loadPartsByProduct(rpv: IRouteParameter[]) : ng.IPromise<ServiceData> {    
      var url : string = "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Part/ByProduct"
      var cacheKey = url + ":" + pglob.RouteData.RouteEntry.RouteParameterStack[0].Id + "-" + pglob.RouteData.RouteEntry.RouteParameterStack[1].Id

      var deferred = this.$q.defer<ServiceData>();
      var dataCache : CacheFactory.ICache = this.getOrCreateCache();

      //in cache?
      if (dataCache.get(cacheKey)) {
        deferred.resolve(dataCache.get(cacheKey));
        return deferred.promise;
      } 

      this.$http<ServiceData>({
        method: "POST"
        , url: url
        , headers: { 'Content-Type': 'application/json' }
        , params: { }
        , data : rpv 
      }).then((response: { data: ServiceData }) => {
        dataCache.put(cacheKey, response.data);
        deferred.resolve(response.data);
      });
      
      return deferred.promise;   
    }   


    public loadAvailabilityByProduct(rpv: IRouteParameter[]): ng.IPromise<AvailabilityServiceData> {    
      var url : string = "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Part/AvailabilityByProduct"
      var cacheKey = url + ":" + pglob.RouteData.RouteEntry.RouteParameterStack[0].Id + "-" + pglob.RouteData.RouteEntry.RouteParameterStack[1].Id

      var deferred = this.$q.defer<AvailabilityServiceData>();
      var dataCache : CacheFactory.ICache = this.getOrCreateCache();

      //in cache?
      if (dataCache.get(cacheKey)) {
        deferred.resolve(dataCache.get(cacheKey));
        return deferred.promise;
      } 

      this.$http<AvailabilityServiceData>({
        method: "POST"
        , url: url
        , headers: { 'Content-Type': 'application/json' }
        , params: { }
        , data : rpv 
      }).then((response: { data: AvailabilityServiceData}) : any => {
        dataCache.put(cacheKey, response.data);
        deferred.resolve(response.data);
      });
      
      return deferred.promise;  

    }   


    public loadDetail(partid : string) : ng.IHttpPromise<PartDetailDTO> {    
      return this.$http<PartDetailDTO>({
        method: "GET"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Part/Detail"
        , headers: { 'Content-Type': 'application/json' }
        , params: { "partid" : partid }
      }).then((response : { data : PartDetailDTO}) : any => { 
        //response.data.References.forEach((ref, i, arr) => {
        //  ref.ProductReferenceDate = new Date(<any>ref.ProductReferenceDate);//we recieve that as string, have to convert it.
        //});
        return response;
      }); 
    }

    public loadDocumentsByPart(partid: string): ng.IHttpPromise<PartDocument[]> {
      return this.$http<PartDocument[]>({
        method: "POST"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Part/Documents"
        , headers: { 'Content-Type': 'application/json' }
        , params: { "itemId": partid }
      }).then((response) => {
        return response;
      })
    }

    public loadYourPrice(): ng.IPromise<YourPrice[]> {
      var cacheKey = "YourPrice";

      var deferred = this.$q.defer<YourPrice[]>();
      var dataCache : CacheFactory.ICache = this.getOrCreateCache();

      //in cache?
      if (dataCache.get(cacheKey)) {
        deferred.resolve(dataCache.get(cacheKey));
        return deferred.promise;
      } 

      this.$http<YourPrice[]>({
        method: "POST"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Part/YourPrice"
        , headers: { 'Content-Type': 'application/json' }
        , params: { }
      }).then((response: { data: YourPrice[]}) : any => {
        dataCache.put(cacheKey, response.data);
        deferred.resolve(response.data);
      });
      
      return deferred.promise;  
    }

    public openDialog(partid: string, parentScp: any, partToProduct? : ErsatzteillistePart2Product | ArtikelReferenz2Object, ev?: MouseEvent) {
      if (ev) ev.preventDefault();
      this.anchorNavService.search("partid", partid);
      this.$mdDialog.show(<ng.material.IDialogOptions>{
        controller: 'PartDetailCtrl',
        templateUrl: 'part/PartDetailCtrl',
        parent: angular.element(document.body),
        bindToController: true,
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          partId: partid,
          partToProduct: partToProduct,
          parentScope: parentScp
        },
      }).then(() => {
        this.anchorNavService.search({ "partid": null });
      }, () => {
        this.anchorNavService.search({ "partid": null });
      });
    }



  }
}